import { useEffect, useState, useRef } from 'react';
import { api } from '../../utils/api';
import { useAuth } from '../../context/AuthContext';

const CANAIS = [
  { nome: 'Mercado Livre', comissao: 16 },
  { nome: 'Shopee', comissao: 12 },
  { nome: 'Amazon', comissao: 20 },
  { nome: 'Loja própria', comissao: 5 },
  { nome: 'Personalizado', comissao: 0 },
];

function calcular(p) {
  const fob = parseFloat(p.fob_usd) || 0;
  const mult = parseFloat(p.multiplicador) || 12;
  const comissao = parseFloat(p.comissao_canal) || 0;
  const nf = parseFloat(p.imposto_nf) || 0;
  const frete = parseFloat(p.frete_cliente) || 0;
  const meta = parseFloat(p.meta_margem) || 80;
  const precoVenda = parseFloat(p.preco_venda_ml) || 0;
  const taxa = parseFloat(p.taxa_dolar) || 1;

  const custoNac = fob * mult;
  const custoNacBRL = custoNac * taxa;

  if (precoVenda === 0) {
    // Calcular preço mínimo para bater a meta
    // lucro = precoVenda - custoNacBRL - comissao% - nf% - frete >= meta% * custoNacBRL
    // precoVenda * (1 - comissao/100 - nf/100) - frete >= custoNacBRL * (1 + meta/100)
    const precoMin = (custoNacBRL * (1 + meta / 100) + frete) / (1 - comissao / 100 - nf / 100);
    return { custoNacBRL, precoMin, lucro: null, margem: null, status: null };
  }

  const descontos = precoVenda * (comissao / 100) + precoVenda * (nf / 100) + frete;
  const lucro = precoVenda - custoNacBRL - descontos;
  const margem = (lucro / custoNacBRL) * 100;
  const status = margem >= meta ? 'viavel' : margem >= meta * 0.7 ? 'atencao' : 'inviavel';

  return { custoNacBRL, precoMin: null, lucro, margem, status };
}

const statusConfig = {
  viavel:   { cor: '#0FA36B', bg: '#E6F7F1', label: '✅ Viável', border: '#B8E6D2' },
  atencao:  { cor: '#E6A817', bg: '#FEF5E4', label: '⚠️ Atenção', border: '#F0D580' },
  inviavel: { cor: '#D63B3B', bg: '#FDEAEA', label: '❌ Inviável', border: '#F5C0C0' },
};

function FormProduto({ onSalvar, alunos }) {
  const [form, setForm] = useState({
    nome: '', fob_usd: '', multiplicador: 12, canal: 'Mercado Livre',
    comissao_canal: 16, imposto_nf: 10, frete_cliente: 20,
    meta_margem: 80, preco_venda_ml: '', observacoes: '', taxa_dolar: ''
  });
  const [salvando, setSalvando] = useState(false);

  const set = (k, v) => setForm(p => ({ ...p, [k]: v }));
  const calc = calcular(form);

  const handleCanal = (nome) => {
    const c = CANAIS.find(x => x.nome === nome);
    set('canal', nome);
    if (c && c.comissao > 0) set('comissao_canal', c.comissao);
  };

  const salvar = async () => {
    if (!form.nome || !form.fob_usd) return;
    setSalvando(true);
    try {
      await onSalvar({
        ...form,
        custo_nacionalizado: calc.custoNacBRL,
        lucro_liquido: calc.lucro,
        margem_real: calc.margem,
        status: calc.status || 'pendente'
      });
      setForm({ nome: '', fob_usd: '', multiplicador: 12, canal: 'Mercado Livre', comissao_canal: 16, imposto_nf: 10, frete_cliente: 20, meta_margem: 80, preco_venda_ml: '', observacoes: '', taxa_dolar: '' });
    } finally { setSalvando(false); }
  };

  const fmtBRL = (v) => v ? `R$ ${parseFloat(v).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}` : '—';

  return (
    <div className="card" style={{marginBottom:20,borderLeft:'3px solid #1A2ECC'}}>
      <div style={{fontSize:14,fontWeight:600,marginBottom:16}}>📦 Novo Produto</div>
      <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:12,marginBottom:12}}>
        <div style={{gridColumn:'1/-1'}}>
          <label style={{fontSize:11,fontWeight:500,color:'#6B7289',display:'block',marginBottom:4}}>Nome do produto *</label>
          <input className="input-field" placeholder="Ex: Moedor de café portátil USB" value={form.nome} onChange={e=>set('nome',e.target.value)} />
        </div>
        <div>
          <label style={{fontSize:11,fontWeight:500,color:'#6B7289',display:'block',marginBottom:4}}>Valor FOB (USD) *</label>
          <input className="input-field" type="number" step="0.01" placeholder="0.00" value={form.fob_usd} onChange={e=>set('fob_usd',e.target.value)} />
        </div>
        <div>
          <label style={{fontSize:11,fontWeight:500,color:'#6B7289',display:'block',marginBottom:4}}>Taxa do dólar (R$) *</label>
          <input className="input-field" type="number" step="0.01" placeholder="Ex: 5.75" value={form.taxa_dolar} onChange={e=>set('taxa_dolar',e.target.value)} />
        </div>
        <div>
          <label style={{fontSize:11,fontWeight:500,color:'#6B7289',display:'block',marginBottom:4}}>Multiplicador de nacionalização</label>
          <input className="input-field" type="number" step="0.5" value={form.multiplicador} onChange={e=>set('multiplicador',e.target.value)} />
        </div>
        <div>
          <label style={{fontSize:11,fontWeight:500,color:'#6B7289',display:'block',marginBottom:4}}>Canal de venda</label>
          <select className="input-field" value={form.canal} onChange={e=>handleCanal(e.target.value)} style={{cursor:'pointer'}}>
            {CANAIS.map(c=><option key={c.nome}>{c.nome}</option>)}
          </select>
        </div>
        <div>
          <label style={{fontSize:11,fontWeight:500,color:'#6B7289',display:'block',marginBottom:4}}>Comissão canal (%)</label>
          <input className="input-field" type="number" step="0.1" value={form.comissao_canal} onChange={e=>set('comissao_canal',e.target.value)} />
        </div>
        <div>
          <label style={{fontSize:11,fontWeight:500,color:'#6B7289',display:'block',marginBottom:4}}>Imposto NF (%)</label>
          <input className="input-field" type="number" step="0.1" value={form.imposto_nf} onChange={e=>set('imposto_nf',e.target.value)} />
        </div>
        <div>
          <label style={{fontSize:11,fontWeight:500,color:'#6B7289',display:'block',marginBottom:4}}>Frete ao cliente (R$)</label>
          <input className="input-field" type="number" step="1" value={form.frete_cliente} onChange={e=>set('frete_cliente',e.target.value)} />
        </div>
        <div>
          <label style={{fontSize:11,fontWeight:500,color:'#6B7289',display:'block',marginBottom:4}}>Meta de margem (%)</label>
          <input className="input-field" type="number" step="1" value={form.meta_margem} onChange={e=>set('meta_margem',e.target.value)} />
        </div>
        <div>
          <label style={{fontSize:11,fontWeight:500,color:'#6B7289',display:'block',marginBottom:4}}>Preço de venda no {form.canal} (R$)</label>
          <input className="input-field" type="number" step="1" placeholder="Deixe vazio para calcular preço mínimo" value={form.preco_venda_ml} onChange={e=>set('preco_venda_ml',e.target.value)} />
        </div>
        <div style={{gridColumn:'1/-1'}}>
          <label style={{fontSize:11,fontWeight:500,color:'#6B7289',display:'block',marginBottom:4}}>Observações</label>
          <textarea className="input-field" rows={2} style={{resize:'none'}} placeholder="Notas sobre o produto, fornecedor, etc." value={form.observacoes} onChange={e=>set('observacoes',e.target.value)} />
        </div>
      </div>

      {/* Preview de cálculo */}
      {form.fob_usd > 0 && (
        <div style={{background:'#F7F8FC',borderRadius:10,padding:14,marginBottom:14}}>
          <div style={{fontSize:11,fontWeight:600,color:'#6B7289',textTransform:'uppercase',letterSpacing:'.06em',marginBottom:10}}>Preview do cálculo</div>
          <div style={{display:'grid',gridTemplateColumns:'repeat(3,1fr)',gap:10}}>
            <div style={{textAlign:'center'}}>
              <div style={{fontSize:11,color:'#6B7289'}}>Custo nacionalizado</div>
              <div style={{fontSize:16,fontWeight:700,color:'#0B0E1A',marginTop:4}}>{fmtBRL(calc.custoNacBRL)}</div>
              <div style={{fontSize:10,color:'#9095A8'}}>FOB × {form.multiplicador} × R${form.taxa_dolar}</div>
            </div>
            {calc.precoMin !== null ? (
              <div style={{textAlign:'center',gridColumn:'2/-1'}}>
                <div style={{fontSize:11,color:'#6B7289'}}>Preço mínimo para {form.meta_margem}% de margem</div>
                <div style={{fontSize:20,fontWeight:700,color:'#1A2ECC',marginTop:4}}>{fmtBRL(calc.precoMin)}</div>
              </div>
            ) : calc.status ? (
              <>
                <div style={{textAlign:'center'}}>
                  <div style={{fontSize:11,color:'#6B7289'}}>Lucro líquido</div>
                  <div style={{fontSize:16,fontWeight:700,color:calc.lucro>=0?'#0FA36B':'#D63B3B',marginTop:4}}>{fmtBRL(calc.lucro)}</div>
                </div>
                <div style={{textAlign:'center'}}>
                  <div style={{fontSize:11,color:'#6B7289'}}>Margem real</div>
                  <div style={{fontSize:16,fontWeight:700,color:statusConfig[calc.status].cor,marginTop:4}}>{calc.margem?.toFixed(1)}%</div>
                  <span style={{fontSize:11,fontWeight:600,color:statusConfig[calc.status].cor}}>{statusConfig[calc.status].label}</span>
                </div>
              </>
            ) : null}
          </div>
        </div>
      )}

      <button className="btn-primary" onClick={salvar} disabled={salvando||!form.nome||!form.fob_usd||!form.taxa_dolar} style={{width:'100%',padding:12}}>
        {salvando ? 'Salvando...' : 'Salvar produto →'}
      </button>
    </div>
  );
}

function ProdutoCard({ produto, alunos, onDelete, onShare, onUpdate }) {
  const [expandido, setExpandido] = useState(false);
  const [alunoSel, setAlunoSel] = useState('');
  const [obs, setObs] = useState(produto.observacoes || '');
  const [salvandoObs, setSalvandoObs] = useState(false);
  const cfg = statusConfig[produto.status] || statusConfig.atencao;
  const fmtBRL = (v) => v ? `R$ ${parseFloat(v).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}` : '—';

  const compartilhar = async () => {
    if (!alunoSel) return;
    await onShare(produto.id, alunoSel);
    setAlunoSel('');
  };

  const salvarObs = async () => {
    setSalvandoObs(true);
    await onUpdate(produto.id, { observacoes: obs });
    setSalvandoObs(false);
  };

  const exportar = () => {
    const txt = `VALIDAÇÃO DE PRODUTO — ${produto.nome}
====================================
Data: ${new Date(produto.criado_em).toLocaleDateString('pt-BR')}
Status: ${cfg.label}

DADOS DE ENTRADA
FOB: USD ${produto.fob_usd}
Multiplicador: ×${produto.multiplicador}
Canal: ${produto.canal} (${produto.comissao_canal}% comissão)
Imposto NF: ${produto.imposto_nf}%
Frete ao cliente: R$ ${produto.frete_cliente}
Meta de margem: ${produto.meta_margem}%
Preço de venda: ${fmtBRL(produto.preco_venda_ml)}

RESULTADO
Custo nacionalizado: ${fmtBRL(produto.custo_nacionalizado)}
Lucro líquido: ${fmtBRL(produto.lucro_liquido)}
Margem real: ${parseFloat(produto.margem_real||0).toFixed(1)}%

${produto.observacoes ? 'OBSERVAÇÕES\n' + produto.observacoes : ''}
`;
    const blob = new Blob([txt], { type: 'text/plain;charset=utf-8' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url; a.download = `validacao_${produto.nome.replace(/\s+/g,'_')}.txt`;
    a.click(); URL.revokeObjectURL(url);
  };

  return (
    <div className="card" style={{marginBottom:12,borderLeft:`3px solid ${cfg.cor}`}}>
      <div style={{display:'flex',alignItems:'center',gap:12}}>
        <div style={{flex:1,minWidth:0}}>
          <div style={{display:'flex',alignItems:'center',gap:8,marginBottom:4}}>
            <span style={{fontSize:14,fontWeight:600,overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{produto.nome}</span>
            <span style={{fontSize:11,fontWeight:600,color:cfg.cor,background:cfg.bg,border:`0.5px solid ${cfg.border}`,padding:'2px 8px',borderRadius:99,flexShrink:0}}>{cfg.label}</span>
          </div>
          <div style={{display:'flex',gap:16,fontSize:12,color:'#6B7289'}}>
            <span>FOB USD {produto.fob_usd} × {produto.multiplicador}</span>
            <span>Custo: {fmtBRL(produto.custo_nacionalizado)}</span>
            <span>Margem: <strong style={{color:cfg.cor}}>{parseFloat(produto.margem_real||0).toFixed(1)}%</strong></span>
            <span>Meta: {produto.meta_margem}%</span>
          </div>
          {produto.compartilhado_nome && (
            <div style={{fontSize:11,color:'#8B5CF6',marginTop:4}}>📤 Compartilhado com {produto.compartilhado_nome}</div>
          )}
        </div>
        <div style={{display:'flex',gap:6,flexShrink:0}}>
          <button onClick={exportar} style={{fontSize:11,color:'#1A2ECC',background:'#EBF0FF',border:'none',borderRadius:6,padding:'5px 10px',cursor:'pointer'}}>📥 Exportar</button>
          <button onClick={()=>setExpandido(!expandido)} style={{fontSize:11,color:'#6B7289',background:'#F4F5F9',border:'none',borderRadius:6,padding:'5px 10px',cursor:'pointer'}}>{expandido?'▲':'▼'}</button>
          <button onClick={()=>onDelete(produto.id)} style={{fontSize:11,color:'#D63B3B',background:'#FDEAEA',border:'none',borderRadius:6,padding:'5px 10px',cursor:'pointer'}}>🗑</button>
        </div>
      </div>

      {expandido && (
        <div style={{marginTop:14,paddingTop:14,borderTop:'0.5px solid #E4E6EF'}}>
          <div style={{display:'grid',gridTemplateColumns:'repeat(4,1fr)',gap:10,marginBottom:14}}>
            {[
              ['Canal', produto.canal],
              ['Comissão', produto.comissao_canal+'%'],
              ['Imposto NF', produto.imposto_nf+'%'],
              ['Frete cliente', `R$ ${produto.frete_cliente}`],
              ['Preço venda', fmtBRL(produto.preco_venda_ml)],
              ['Custo nac.', fmtBRL(produto.custo_nacionalizado)],
              ['Lucro líq.', fmtBRL(produto.lucro_liquido)],
              ['Margem real', parseFloat(produto.margem_real||0).toFixed(1)+'%'],
            ].map(([l,v])=>(
              <div key={l} style={{background:'#F7F8FC',borderRadius:8,padding:'8px 10px'}}>
                <div style={{fontSize:10,color:'#6B7289'}}>{l}</div>
                <div style={{fontSize:13,fontWeight:600,marginTop:2}}>{v}</div>
              </div>
            ))}
          </div>

          {/* Observações */}
          <div style={{marginBottom:14}}>
            <label style={{fontSize:11,fontWeight:500,color:'#6B7289',display:'block',marginBottom:4}}>Observações</label>
            <textarea value={obs} onChange={e=>setObs(e.target.value)} rows={2}
              style={{width:'100%',fontSize:12,padding:'8px 10px',border:'0.5px solid #E4E6EF',borderRadius:8,resize:'none',outline:'none',fontFamily:'inherit',marginBottom:6}} />
            <button onClick={salvarObs} disabled={salvandoObs}
              style={{fontSize:11,background:'#1A2ECC',color:'#fff',border:'none',borderRadius:6,padding:'5px 12px',cursor:'pointer'}}>
              {salvandoObs?'Salvando...':'Salvar observações'}
            </button>
          </div>

          {/* Compartilhar */}
          <div>
            <label style={{fontSize:11,fontWeight:500,color:'#6B7289',display:'block',marginBottom:4}}>Compartilhar com aluno</label>
            <div style={{display:'flex',gap:8}}>
              <select value={alunoSel} onChange={e=>setAlunoSel(e.target.value)}
                style={{flex:1,padding:'8px 10px',border:'0.5px solid #E4E6EF',borderRadius:8,fontSize:12,cursor:'pointer'}}>
                <option value="">Selecione um aluno</option>
                {alunos.map(a=><option key={a.id} value={a.id}>{a.nome}</option>)}
              </select>
              <button onClick={compartilhar} disabled={!alunoSel}
                style={{fontSize:11,fontWeight:600,background:'#8B5CF6',color:'#fff',border:'none',borderRadius:8,padding:'8px 14px',cursor:'pointer'}}>
                📤 Compartilhar
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default function MentorProdutos() {
  const { token } = useAuth();
  const [produtos, setProdutos] = useState([]);
  const [alunos, setAlunos] = useState([]);
  const [criando, setCriando] = useState(false);
  const [filtro, setFiltro] = useState('');
  const [filtroStatus, setFiltroStatus] = useState('');

  const load = () => api.get('/produtos', token).then(setProdutos);
  useEffect(() => {
    load();
    api.get('/mentor/alunos', token).then(setAlunos).catch(()=>{});
  }, [token]);

  const salvar = async (dados) => {
    await api.post('/produtos', dados, token);
    await load();
    setCriando(false);
  };

  const excluir = async (id) => {
    if (!window.confirm('Excluir este produto?')) return;
    await api.del(`/produtos/${id}`, token);
    setProdutos(prev => prev.filter(p => p.id !== id));
  };

  const compartilhar = async (id, alunoId) => {
    await api.patch(`/produtos/${id}`, { compartilhado_com: alunoId }, token);
    await load();
  };

  const atualizar = async (id, dados) => {
    await api.patch(`/produtos/${id}`, dados, token);
    await load();
  };

  const filtrados = produtos.filter(p => {
    const matchNome = !filtro || p.nome.toLowerCase().includes(filtro.toLowerCase());
    const matchStatus = !filtroStatus || p.status === filtroStatus;
    return matchNome && matchStatus;
  });

  const stats = {
    total: produtos.length,
    viaveis: produtos.filter(p=>p.status==='viavel').length,
    atencao: produtos.filter(p=>p.status==='atencao').length,
    inviaveis: produtos.filter(p=>p.status==='inviavel').length,
  };

  return (
    <div style={{padding:'28px 32px'}}>
      <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',marginBottom:20}}>
        <div>
          <div style={{fontSize:22,fontWeight:700,letterSpacing:'-.02em'}}>Validador de Produtos</div>
          <div style={{fontSize:13,color:'#6B7289',marginTop:3}}>Análise de viabilidade para importação e venda</div>
        </div>
        <button className="btn-primary" onClick={()=>setCriando(!criando)}>
          {criando ? '✕ Cancelar' : '+ Novo Produto'}
        </button>
      </div>

      {/* Stats */}
      <div style={{display:'grid',gridTemplateColumns:'repeat(4,1fr)',gap:10,marginBottom:20}}>
        {[
          ['Total', stats.total, '#1A2ECC'],
          ['Viáveis ✅', stats.viaveis, '#0FA36B'],
          ['Atenção ⚠️', stats.atencao, '#E6A817'],
          ['Inviáveis ❌', stats.inviaveis, '#D63B3B'],
        ].map(([l,v,c])=>(
          <div key={l} className="card" style={{padding:14,cursor:'pointer'}} onClick={()=>setFiltroStatus(l.includes('✅')?'viavel':l.includes('⚠️')?'atencao':l.includes('❌')?'inviavel':'')}>
            <div style={{fontSize:10,color:'#6B7289',textTransform:'uppercase',letterSpacing:'.06em'}}>{l}</div>
            <div style={{fontSize:24,fontWeight:700,color:c,marginTop:4}}>{v}</div>
          </div>
        ))}
      </div>

      {criando && <FormProduto onSalvar={salvar} alunos={alunos} />}

      {/* Filtros */}
      <div style={{display:'flex',gap:10,marginBottom:16}}>
        <input className="input-field" placeholder="Buscar produto..." value={filtro} onChange={e=>setFiltro(e.target.value)} style={{flex:1}} />
        <select className="input-field" value={filtroStatus} onChange={e=>setFiltroStatus(e.target.value)} style={{width:160,cursor:'pointer'}}>
          <option value="">Todos os status</option>
          <option value="viavel">Viável</option>
          <option value="atencao">Atenção</option>
          <option value="inviavel">Inviável</option>
        </select>
      </div>

      {filtrados.length===0 && (
        <div className="card" style={{textAlign:'center',padding:40}}>
          <div style={{fontSize:32,marginBottom:12}}>📦</div>
          <div style={{fontSize:14,fontWeight:600,marginBottom:8}}>Nenhum produto ainda</div>
          <div style={{fontSize:13,color:'#6B7289'}}>Clique em "Novo Produto" para começar a validar.</div>
        </div>
      )}

      {filtrados.map(p=>(
        <ProdutoCard key={p.id} produto={p} alunos={alunos} onDelete={excluir} onShare={compartilhar} onUpdate={atualizar} />
      ))}
    </div>
  );
}
